<template>
  <form-group v-bind="$attrs">
    <v-row>
      <v-col cols="6">
        <bloqueio-options :payload="payload" />
      </v-col>
      <v-col cols="6">
        <select-conta-id :payload="payload" />
      </v-col>
    </v-row>
  </form-group>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import BloqueioOptions from '../inputs/BloqueioOptions.vue';
import SelectContaId from '../inputs/SelectContaId.vue';

export default {
  name: 'ProdutoTransferencia',
  components: {
    BloqueioOptions,
    SelectContaId,
    FormGroup,
  },
  props: {
    payload: {
      type: Object,
      default() {
        return {
          id: '',
          idRegionalMarca: '',
          indBloqueado: '',
          idConta: '',
          descricaoValor: '',
          tipoValorProduto: '',
          vlrProdutoServico: '',
          vlrVariavelMin: '',
          vlrVariavelMax: '',
        };
      },
    },
  },
};
</script>
